import audio from '@/scripts/audio';
import store from '@/store';
import gsap from 'gsap/gsap-core';
import { random } from 'lodash';
import { Loader, Point, Sprite } from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import { hitTestCenter } from '../utils';
import vars from '../vars';
import Actor from './Actor';

class Powerup extends Actor {
  constructor(parent, player) {
    super(parent);
    this.player = player;
    this.catched = false;
    const r = random(1, 3, false);
    this.type = r === 1 ? 'refill' : (r === 2) ? 'speed' : 'shield'; // eslint-disable-line

    this.sprite = new Sprite();
    this.powerup = new Sprite(Loader.shared.resources[`textures/FRUIT_${r}`].texture);
    this.shadow = new Sprite(Loader.shared.resources[`textures/FRUIT_${r}_SHADOW`].texture);

    this.frameHandler = () => { this.frame(); };

    this.sprite.addChild(this.shadow);
    this.sprite.addChild(this.powerup);
    this.resize();
    this.parent.addChild(this.sprite);

    ticker.add(this.frameHandler);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.shadow.anchor = new Point(0.5, 0.5);
    this.powerup.anchor = new Point(0.5, 0.5);
  }

  frame() {
    const { top } = this.sprite.getBounds();
    this.shadow.position.y = (top - (vars.layout.FRAME_HEIGHT / 2)) * 0.03;
    this.shadow.position.x = (this.player.sprite.position.x - (vars.layout.FRAME_WIDTH / 2)) * 0.05;

    if (hitTestCenter(this.sprite, this.player.sprite) && !this.player.jumping) {
      this.catch();
      this.destroy();
    }
  }

  catch() {
    this.catched = true;
    gsap.to(this.sprite.scale, {
      x: 0,
      y: 0,
      ease: 'power2.in',
      duration: 0.2,
    }).then(() => {
      this.sprite.renderable = false;
    });

    if (this.type === 'refill') {
      state.fuel = 100;
      audio.play('full');
      this.player.confetti.play();
      state.hasPowerupOnStage = false;
    }
    if (this.type === 'speed') {
      audio.play('shield');
      store.state.userData.data.strawberries = parseInt(store.state.userData.data.strawberries, 10) + 1;
      this.player.isButterfly = true;
      this.player.butterflyShield.gotoAndStop(0);
      this.player.butterflyShieldBack.gotoAndStop(0);
      this.player.butterflyShield.play();
      this.player.butterflyShieldBack.play();
      setTimeout(() => {
        this.player.tail.sprite.renderable = false;
        this.player.butterflyIn.renderable = true;
      }, 440);
      setTimeout(() => this.player.butterflyIn.play(), 600);
      this.player.butterflyShield.onComplete = () => {
        audio.play('butterfly');
        this.player.butterflyIn.onComplete = () => {
          state.speed = 6;
          this.player.butterflyIn.renderable = false;
          this.player.butterfly.renderable = true;
          this.player.butterflyShadow.renderable = true;
          this.player.butterfly.play();
        };
      };

      // Back to normal after... 4s?
      setTimeout(() => {
        this.player.butterflyShield.gotoAndStop(0);
        this.player.butterflyShieldBack.gotoAndStop(0);
        this.player.butterflyIn.gotoAndStop(0);
        this.player.butterflyShield.play();
        audio.play('shield');
        this.player.butterflyShieldBack.play();
        this.player.butterflyShield.onComplete = () => {};
        state.speed = state.initialSpeed;
        setTimeout(() => {
          this.player.butterfly.renderable = false;
          this.player.butterflyShadow.renderable = false;
          this.player.tail.sprite.renderable = true;
          this.player.isButterfly = false;
          state.hasPowerupOnStage = false;
        }, 440);
      }, 4000);
    }
    if (this.type === 'shield') {
      audio.play('bubble');
      this.player.setTemporaryInvincible(4000);
      store.state.userData.data.blueberries = parseInt(store.state.userData.data.blueberries, 10) + 1;
    }
  }

  destroy() {
    if (!this.catched) state.hasPowerupOnStage = false;
    ticker.remove(this.frameHandler);
  }
}

export default Powerup;
